/**
 * ShopifyUtils
 * Direct conversion from TypeScript master utilities/ShopifyUtils.ts
 */
// @ts-nocheck
export function formatMoney(cents, format = '${{amount}}') {
  if (typeof cents == 'string') {
    cents = ~~(cents).replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = (format || window.Shopify?.format?.money || '${{amount}}');

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    const sNumber = (number / 100.0).toFixed(precision);
    const parts = sNumber.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  const match = formatString.match(placeholderRegex);
  if (match) {
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

export function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|3000x3000|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/gi, function (match) {
      return '_' + size + match;
    });
}

